import React from "react";
import SystemGraphs from "./SystemGraphs";

const BoxElderUnion = () => {
  const defaultParameter = 67;

  const pageTitle = "Box Elder/Union";

  const endpoints = [
    { label: "15 Minutes", value: "display010-data15-min" },
    { label: "Daily", value: "display010-data-daily" },
  ];

  const parametersEndpoint = "display010-lookup-parameter";

  const mapEndpoint = "display010-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        displayIndex="010"
      />
    </>
  );
};

export default BoxElderUnion;
